import {Http} from 'vue-resource'
import config from '../config'

class QuestionService {
  getQuestions (intakeId = null) {
    return Http.get(config.API_URL + 'api/questions', {params:  {intakeId: intakeId}});
  }
}

const instance = new QuestionService()

export default instance;
